import { Dialog, DialogContent } from "./ui/dialog";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect } from "react";

export default function Lightbox({ images, index, onClose, onPrev, onNext }) {
  const open = index !== null && index >= 0;
  const img = open ? images[index] : null;

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onPrev, onNext, onClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        data-testid="gallery-lightbox"
        className="max-w-5xl bg-slate-900/95 border-slate-800 p-0 overflow-hidden"
      >
        {img && (
          <div className="relative">
            <img
              src={img.url}
              alt={img.title}
              className="w-full max-h-[80vh] object-contain bg-black"
            />
            <button
              onClick={onClose}
              data-testid="lightbox-close"
              className="absolute top-3 right-3 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
            >
              <X className="w-5 h-5" />
            </button>
            <button
              onClick={onPrev}
              data-testid="lightbox-prev"
              className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={onNext}
              data-testid="lightbox-next"
              className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
              <div className="text-white font-display text-lg">{img.title}</div>
              <div className="text-slate-300 text-xs">
                {index + 1} / {images.length}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
